import type { PRMarinaNode } from '@sketch-hq/sketch-web-renderer'

export type AnnotatableNode =
  | { type: 'ARTBOARD'; node: PRMarinaNode }
  | { type: 'SECTION'; node: PRMarinaNode }
  | { type: 'PAGE'; node: PRMarinaNode }

/**
 * Walks up from the given node until it finds the nearest ancestor (or the node
 * itself) that's a top-level frame, a section, or a page — the set of containers
 * annotations can be pinned to. Returns null if none of the node's ancestors match
 * (e.g. the node was deleted from the tree).
 */
export const getAnnotatableNode = (
  node: PRMarinaNode | null
): AnnotatableNode | null => {
  let current: PRMarinaNode | null = node

  while (current) {
    if (current.isTopLevelFrame()) {
      return { type: 'ARTBOARD', node: current }
    }

    if (current.isSection()) {
      return { type: 'SECTION', node: current }
    }

    if (current.isPage()) {
      return { type: 'PAGE', node: current }
    }

    current = current.getParentNode()
  }

  return null
}
